import * as React from 'react';
import { compose } from 'recompose';
import { withAnalyticOnView, enrichAnalytics } from 'react-shisell';
import { PageProps } from './Page';

export type SectionProps = {
  sectionName: string
  className?: string
  mapPropsToExtras?: (props: any) => object
}

const Section: React.SFC<SectionProps & React.HTMLAttributes<HTMLDivElement>> = ({ children, className, ...props }) => (
  <div className={className} onClick={props.onClick}>
    {children}
  </div>
)

export default compose<{}, SectionProps>(
  enrichAnalytics<SectionProps & PageProps>((dispatcher, { sectionName }) => dispatcher.withExtras({ 'Section': sectionName })),
  withAnalyticOnView<SectionProps>({
    analyticName: 'SectionView',
    mapPropsToExtras: ({ mapPropsToExtras, ...props }) => mapPropsToExtras ? mapPropsToExtras(props) : {},
  })
)(Section);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/containers/Section.tsx